export const LinkShorteningDomains = {
  NoShortening: 'No Shortening',
  DefaultShortener: 'buff.ly',
} as const
